import React from 'react';
import Card from 'react-bootstrap/Card';
import { Link } from 'react-router-dom';
import StarRatings from 'react-star-ratings';
import Captain from "../../assets/badges/captain.png";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'

const Tile = (props) => {

    const { rideInfo } = props
    return (
        <div className="tile__main">
            <Card style={{ width: '18rem' }}>
                <Link to={{
                    pathname: `/ride/${rideInfo.objectId}`,
                    state: rideInfo
                }}>
                    <Card.Img variant="top" src={rideInfo.images} alt={"picture of: " + rideInfo.title} />
                        {/* START - CAPTAIN PACKAGE? */}
                        {
                            rideInfo.details.captain 
                            ? 
                            <OverlayTrigger
                                overlay={
                                    <Tooltip>
                                        <span>Captain's Package Available</span>
                                    </Tooltip>
                                }
                            >
                                <img src={Captain} className="tile__captain"/>
                            </OverlayTrigger> 
                            : 
                            null
                        }
                        {/* END - CAPTAIN PACKAGE? */}
                    <Card.Body>
                        <Card.Title>{rideInfo.title}</Card.Title>
                        <Card.Subtitle>{rideInfo.subtitle}</Card.Subtitle>
                    </Card.Body>
                    <Card.Footer>
                        <Card.Text><i className="fas fa-map-marker-alt"></i> {rideInfo.city}</Card.Text>
                        <small>
                            {/* START - RATING? */}
                            {
                                rideInfo.rating === 0 
                                ? 
                                <span>Not Rated</span> 
                                :
                                <StarRatings
                                    rating={rideInfo.rating}
                                    starRatedColor="#0888be"
                                    starDimension="15px"
                                    starSpacing="0px"
                                />
                            }
                            {/* END - RATING? */}
                        </small>
                        <span className="tile__price">${rideInfo.priceD} per day</span>
                    </Card.Footer>
                </Link>
            </Card>
        </div>
    )
}
export default Tile